/* eslint-disable import/no-require */
import React from 'react';
import { Redirect, Route, IndexRoute } from 'react-router';
import TermView from '../components/term_view.jsx';

export default (
    <Route component={require('../controllerviews/login.jsx').default}>
        <Route
            path="/"
            component={require('../controllerviews/app.jsx').default}
        >
            <IndexRoute component={require('../components/root.jsx').default} />

            <Route
                path="content-:contentId"
                component={require('../controllerviews/content.jsx').default}
            ></Route>

            <Route
                path="section/:sectionId"
                component={require('../components/section_view.jsx').default}
            >
                <Route
                    path="analytics/:contentId"
                    component={
                        require('../components/analytics_dialog.jsx').default
                    }
                />

                <Route
                    path="manage/:manage"
                    component={
                        require('../components/manage_content.jsx').default
                    }
                />
            </Route>

            <Route path="term/:termId" component={TermView}>
                <Route
                    path="logout"
                    component={require('../components/logout.jsx').default}
                />

                <Route
                    path="analytics/:contentId"
                    component={
                        require('../components/analytics_dialog.jsx').default
                    }
                />

                <Route
                    path="manage/:manage"
                    component={
                        require('../components/manage_content.jsx').default
                    }
                />
            </Route>
        </Route>
        <Redirect from="*" to="/" />
    </Route>
);



// WEBPACK FOOTER //
// ./src/router/routes.jsx